// Phase 5 payloads (app/api/prospects.py).

export const PROSPECT_STATUS = ['researched', 'selected', 'draft_ready', 'contacted', 'replied', 'meeting', 'opportunity', 'closed', 'not_relevant'] as const;
export const PROSPECT_KIND = ['architect', 'developer', 'agency', 'other'] as const;
export const INTERACTION_KIND = ['note', 'email_received', 'call', 'meeting', 'enquiry', 'message', 'other'] as const;

export const STATUS_TEXT: Record<string, string> = {
  researched: 'Researched',
  selected: 'Selected',
  draft_ready: 'Draft ready',
  contacted: 'Contacted',
  replied: 'Replied',
  meeting: 'Meeting',
  opportunity: 'Opportunity',
  closed: 'Closed',
  not_relevant: 'Not relevant',
};

export interface ProspectRow {
  id: string;
  name: string;
  kind: string;
  country: string | null;
  city: string | null;
  website_url: string | null;
  primary_domain: string | null;
  relevant_project: string | null;
  fit_reason: string | null;
  status: string;
  next_action: string | null;
  next_action_due: string | null;
  notes: string | null;
  competitor_studio_id: string | null;
  is_demo: boolean;
  created_at: string;
  updated_at: string;
  version: number;
  last_interaction_at?: string | null;
  contacts?: number;
  overdue?: boolean;
}

export interface ProspectList {
  items: ProspectRow[];
  total: number;
  by_status: Record<string, number>;
  follow_ups_due: number;
  today: string;
}

export interface PFact {
  id: string;
  field: string;
  value: string;
  source_url: string | null;
  excerpt: string | null;
  method: string;
  state: 'proposed' | 'verified' | 'rejected';
  observed_at: string;
  job_id: string | null;
}

export interface PContact {
  id: string;
  name: string | null;
  role: string | null;
  email: string | null;
  email_source: string | null;
  phone: string | null;
  profile_url: string | null;
  opted_out: boolean;
  blocked: string | null;
  last_emailed_at: string | null;
}

export interface Draft {
  id: string;
  contact_id: string | null;
  language: string;
  subject: string;
  body: string;
  status: 'draft' | 'approved' | 'sent_manually' | 'discarded';
  basis: { facts?: string[]; projects?: string[] };
  generated_by: string;
  model: { provider?: string; model?: string; is_local?: boolean } | null;
  warnings: string[];
  placeholders: string[];
  approved_at: string | null;
  sent_at: string | null;
  created_at: string;
  updated_at: string;
  version: number;
}

export interface ProspectDetail extends Omit<ProspectRow, 'contacts'> {
  competitor: { id: string; name: string } | null;
  blocked: string | null;
  facts: PFact[];
  contacts: PContact[];
  drafts: Draft[];
  interactions: { id: string; kind: string; occurred_at: string; summary: string; outcome: string | null; contact_id: string | null; draft_id: string | null }[];
  jobs: { id: string; type: string; status: string; error: string | null; created_at: string }[];
  model_drafts: { enabled: boolean; reason: string | null };
  materials: { id: string; title: string; location: string | null; description: string; services: string[] }[];
  repeat_days: number;
}

export interface SuppressionRow {
  id: string;
  kind: 'email' | 'domain';
  value: string;
  reason: string;
  created_at: string;
}
